import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import Phusaphin from './image/booking/phusaphin.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: "06:30 PM", description: "Xe khởi hành từ Hà Nội, hướng về vùng cao Xím Vàng - Sơn La" },
      { time: "11:30 PM", description: "Có mặt và nhận phòng tại homestay yên bình tại Xím Vàng" },
      { 
        description: "Một giấc ngủ sâu giữa không khí se lạnh của vùng cao là liều thuốc quý giá nhất. Hãy để cơ thể được nghỉ ngơi hoàn toàn, sẵn sàng cho hành trình chạm tay vào mây trời ngày mai." 
      }
    ],
  },
  {
    day: "Thứ 7 - Khám Phá Đại Ngàn Xím Vàng",
    activities: [
      { time: "06:30 AM", description: "Thưởng thức bữa sáng ấm nóng giữa mây ngàn Xím Vàng" },
      { 
        description: "Bữa sáng đầy đủ dinh dưỡng với tinh bột và đạm sẽ là nguồn năng lượng bền bỉ cho bạn. Đừng quên gửi lại những hành lý nặng tại homestay, chỉ mang theo những gì cần thiết nhất cho tâm hồn tự do." 
      },
      { time: "07:30 AM", description: "Xe ôm bản địa đưa đoàn băng qua những đồi chè cổ thụ đến điểm leo" },
      { 
        description: "Cảm giác ngồi sau tay lái, hít hà mùi cỏ cây và ngắm nhìn những bản làng người Mông chìm trong sương sớm là trải nghiệm khó quên. Mỗi khúc cua là một khung hình tuyệt đẹp để bạn lưu giữ thanh xuân." 
      },
      { time: "09:00 AM", description: "Bắt đầu hành trình chinh phục đỉnh Phu Sa Phìn" },
      { 
        description: "Chúng ta sẽ đi dưới những tán rừng già, nơi có những gốc đỗ quyên cổ thụ và rêu phong phủ kín. Hãy cứ đi thật chậm, cảm nhận hơi thở của rừng và để thiên nhiên chữa lành tâm hồn." 
      },
      { time: "12:00 PM", description: "Nghỉ chân và dùng bữa trưa giữa rừng" },
      { 
        description: "Một bữa trưa picnic giản đơn nhưng đậm chất núi rừng. Sau khi dùng bữa, hãy dành 15 phút nhắm mắt lại, lắng nghe tiếng chim hót và tiếng lá xào xạc để hồi phục tinh thần." 
      },
      { time: "02:30 PM", description: "Chạm đỉnh Phu Sa Phìn - Nơi mây và trời hòa làm một" },
      { 
        description: "Đứng trên đỉnh cao, phóng tầm mắt ra biển mây bồng bềnh, bạn sẽ thấy mọi nỗ lực đều xứng đáng. Hãy lưu lại những bức ảnh 'để đời' trong ánh nắng chiều rực rỡ nhé." 
      },
      { time: "05:00 PM", description: "Di chuyển về lán nghỉ gần đỉnh núi" },
      { 
        description: "Lán gỗ ấm cúng giữa đỉnh cao, nơi không có sóng điện thoại để chúng ta thực sự kết nối với nhau. Một đêm ngủ giữa ngàn sao, trong hơi ấm của chăn đệm sẵn có." 
      },
    ],
  },
  {
    day: "Chủ Nhật - Sống Lưng Khủng Long & Suối Khoáng",
    activities: [
      { time: "06:00 AM", description: "Thức dậy đón bình minh rực rỡ trên đỉnh núi" },
      { 
        description: "Khoảnh khắc những cột nắng đầu tiên xuyên qua biển mây là lúc thiên nhiên đẹp nhất. Hãy tận hưởng tách trà nóng và hít căng lồng ngực không khí trong lành này." 
      },
      { time: "08:00 AM", description: "Bắt đầu xuống núi theo hướng Trạm Tấu" },
      { time: "09:30 AM", description: "Check-in 'Sống lưng huyền thoại' của Phu Sa Phìn" },
      { 
        description: "Đây là đoạn đường đẹp nhất hành trình với những sống núi hùng vĩ chạy dài. Hãy bước đi thật vững chắc, thắt chặt dây giày và cùng nhau tạo nên những thước phim ấn tượng nhất." 
      },
      { time: "12:30 PM", description: "Dùng bữa trưa nhẹ và nghỉ ngơi trước khi xuống bản" },
      { time: "03:30 PM", description: "Về tới Trạm Tấu, thư giãn tại suối khoáng nóng" },
      { 
        description: "Còn gì tuyệt vời hơn khi được ngâm mình trong làn nước khoáng nóng tự nhiên, để hơi ấm xoa dịu từng thớ cơ mệt mỏi và làm làn da thêm rạng rỡ sau chuyến đi." 
      },
      { time: "05:30 PM", description: "Dùng bữa tối liên hoan mừng thành công tại Trạm Tấu" },
      { 
        description: "Thưởng thức những món đặc sản vùng cao thay cho lời cảm ơn vì sự nỗ lực và đồng hành của tất cả các bạn trong suốt hành trình qua." 
      },
      { time: "07:00 PM", description: "Lên xe trở về Hà Nội" },
      { time: "11:30 PM", description: "Về tới Hà Nội, khép lại hành trình đầy cảm xúc và những ký ức đáng giá."}
    ],
  },
];

const PhuSaPhinSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>Phu Sa Phìn – Sống lưng huyền thoại Tây Bắc</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Phu Sa Phìn (hay còn gọi là đỉnh Tà Xùa) – ngọn núi cao 2.868 mét, là đỉnh cao nhất của dãy Tà Xùa,
           không chỉ là thử thách dành cho người đam mê trekking mà còn là “Thiên đường săn mây” lãng mạn bậc nhất.
            Nơi đây hứa hẹn một trải nghiệm phiêu lưu kỳ thú xuyên qua những cảnh quan có một không hai.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Biển mây trên mỏm Đầu Rùa Phu Sa Phìn
        </p>
        <img src={Phusaphin} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default PhuSaPhinSchedule;